import { useUser } from "../use-user";

export const useIsUserVerified = () => {
  const user = useUser();

  return !!user?.is_verified;
};
